import View from "./View";
import { Sentinel } from "./common";

const ErrorView = View.extend(
  /** @lends ErrorView.prototype */
  {
    /**
     * Simple view for error messages of individual files.
     * Automatically shows/hides on file state change depending on whether it has an error.
     * @param {FileModel} model
     * @param {object} opts
     * @constructs
     * @extends View
     */
    constructor(model, opts) {
      View.call(this, model, opts);

      this.messageSentinel = new Sentinel();

      this.messageNode = document.createTextNode("");

      this.setHTML(this.opts.template.parse("image_error", {
        message: this.messageSentinel.string
      }));
    },

    /**
     * React to state change by showing/hiding itself
     * @param {*} state
     * @private
     */
    handleStateChange(state) {
      const error = this.model.getError();

      if(error) {
        this.messageNode.textContent = error;
        this.show();
      } else {
        this.hide();
      }
    },

    onMount() {
      const messageSentinelRef = this.messageSentinel.getReference();
      messageSentinelRef.parentNode.insertBefore(this.messageNode, messageSentinelRef);
      this.messageSentinel.remove();

      this.handleStateChange(this.model.state);
      this.listenTo(this.model, "state_changed", ({ state }) => this.handleStateChange(state));
    }
  });

export default ErrorView;
